// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forgot-page-wrapper {
    min-height: 100vh;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--bg-page);
    background-size: cover;
    padding: 20px;
}

.auth-card {
    width: 100%;
    max-width: 420px;
    background-color: var(--bg-card);
    padding: 40px;
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-card);
    display: flex;
    flex-direction: column;
    gap: 24px;
    animation: slideUp 0.5s ease-out;
    position: relative;
}

@keyframes slideUp {
    from { opacity: 0; transform: translateY(20px); }
    to { opacity: 1; transform: translateY(0); }
}

.auth-header {
    text-align: center;
}

.auth-header h1 {
    font-size: 1.5rem;
    font-weight: 800;
    color: var(--text-main);
    margin: 0 0 8px 0;
}

.auth-subtitle {
    color: var(--text-muted);
    font-size: 0.95rem;
    line-height: 1.5;
    margin: 0;
}

.auth-form {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.form-group input {
    width: 100%;
    height: 52px;
    padding: 0 16px;
    background-color: var(--bg-input);
    border: 1px solid var(--border-light);
    border-radius: var(--radius-input);
    font-size: 1rem;
    color: var(--text-main);
    transition: var(--transition);
    box-sizing: border-box;
}

.form-group input:focus {
    outline: none;
    background-color: #fff;
    border-color: var(--brand-primary);
    box-shadow: var(--shadow-input-focus);
}

.action-button {
    height: 52px;
    width: 100%;
    padding: 0 24px;
    box-sizing: border-box;
    background-color: var(--brand-accent);
    color: var(--brand-accent-fg);
    border: none;
    border-radius: var(--radius-input);
    font-size: 1rem;
    font-weight: 700;
    cursor: pointer;
    transition: var(--transition);
    box-shadow: 0 4px 12px rgba(210, 248, 0, 0.25);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
}

.action-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(210, 248, 0, 0.4);
    filter: brightness(1.05);
}

.action-button:active {
    transform: scale(0.98);
}

.secondary-button {
    background-color: var(--brand-accent);
    color: var(--text-main) !important;
    border: 2px solid var(--border-light);
    box-shadow: none;
}

.secondary-button:hover {
    background-color: var(--bg-page);
    border-color: var(--brand-primary);
    transform: translateY(-2px);
    box-shadow: var(--shadow-card);
}

.back-link {
    text-align: center;
    margin-top: 8px;
}

.back-link a {
    color: var(--text-muted);
    font-size: 0.9rem;
    text-decoration: none;
    font-weight: 500;
    transition: var(--transition);
    display: inline-flex;
    align-items: center;
    gap: 6px;
}

.back-link a:hover {
    color: var(--brand-primary);
}

.error-banner {
    background-color: #FEF2F2;
    border: 1px solid #FECACA;
    color: var(--error);
    padding: 12px;
    border-radius: var(--radius-input);
    font-size: 0.9rem;
    text-align: center;
}

.success-state {
    text-align: center;
    padding: 20px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    animation: fadeIn 0.5s ease;
}

.success-icon {
    width: 64px;
    height: 64px;
    background-color: #DCFCE7;
    color: #16A34A;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 32px;
    margin-bottom: 8px;
}

.success-text {
    color: var(--text-muted);
    font-size: 0.95rem;
    line-height: 1.5;
}

@media (max-width: 480px) {
    .forgot-page-wrapper {
        padding: 0;
        background-color: var(--bg-card);
    }

    .auth-card {
        box-shadow: none;
        height: 100vh;
        justify-content: center;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Auth/ForgotPassword.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gCAAgC;IAChC,aAAa;IACb,+BAA+B;IAC/B,8BAA8B;IAC9B,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,iCAAiC;IACjC,qCAAqC;IACrC,kCAAkC;IAClC,eAAe;IACf,uBAAuB;IACvB,6BAA6B;IAC7B,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kCAAkC;IAClC,qCAAqC;AACzC;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,qCAAqC;IACrC,6BAA6B;IAC7B,YAAY;IACZ,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,8CAA8C;IAC9C,yBAAyB;IACzB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;IAC3B,6CAA6C;IAC7C,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,qCAAqC;IACrC,kCAAkC;IAClC,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,kCAAkC;IAClC,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;IAChB,6BAA6B;IAC7B,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,kCAAkC;IAClC,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI;QACI,UAAU;QACV,gCAAgC;IACpC;;IAEA;QACI,gBAAgB;QAChB,aAAa;QACb,uBAAuB;IAC3B;AACJ","sourcesContent":[".forgot-page-wrapper {\n    min-height: 100vh;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: var(--bg-page);\n    background-size: cover;\n    padding: 20px;\n}\n\n.auth-card {\n    width: 100%;\n    max-width: 420px;\n    background-color: var(--bg-card);\n    padding: 40px;\n    border-radius: var(--radius-lg);\n    box-shadow: var(--shadow-card);\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    animation: slideUp 0.5s ease-out;\n    position: relative;\n}\n\n@keyframes slideUp {\n    from { opacity: 0; transform: translateY(20px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n\n.auth-header {\n    text-align: center;\n}\n\n.auth-header h1 {\n    font-size: 1.5rem;\n    font-weight: 800;\n    color: var(--text-main);\n    margin: 0 0 8px 0;\n}\n\n.auth-subtitle {\n    color: var(--text-muted);\n    font-size: 0.95rem;\n    line-height: 1.5;\n    margin: 0;\n}\n\n.auth-form {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.form-group input {\n    width: 100%;\n    height: 52px;\n    padding: 0 16px;\n    background-color: var(--bg-input);\n    border: 1px solid var(--border-light);\n    border-radius: var(--radius-input);\n    font-size: 1rem;\n    color: var(--text-main);\n    transition: var(--transition);\n    box-sizing: border-box;\n}\n\n.form-group input:focus {\n    outline: none;\n    background-color: #fff;\n    border-color: var(--brand-primary);\n    box-shadow: var(--shadow-input-focus);\n}\n\n.action-button {\n    height: 52px;\n    width: 100%;\n    padding: 0 24px;\n    box-sizing: border-box;\n    background-color: var(--brand-accent);\n    color: var(--brand-accent-fg);\n    border: none;\n    border-radius: var(--radius-input);\n    font-size: 1rem;\n    font-weight: 700;\n    cursor: pointer;\n    transition: var(--transition);\n    box-shadow: 0 4px 12px rgba(210, 248, 0, 0.25);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-decoration: none;\n}\n\n.action-button:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 6px 16px rgba(210, 248, 0, 0.4);\n    filter: brightness(1.05);\n}\n\n.action-button:active {\n    transform: scale(0.98);\n}\n\n.secondary-button {\n    background-color: var(--brand-accent);\n    color: var(--text-main) !important;\n    border: 2px solid var(--border-light);\n    box-shadow: none;\n}\n\n.secondary-button:hover {\n    background-color: var(--bg-page);\n    border-color: var(--brand-primary);\n    transform: translateY(-2px);\n    box-shadow: var(--shadow-card);\n}\n\n.back-link {\n    text-align: center;\n    margin-top: 8px;\n}\n\n.back-link a {\n    color: var(--text-muted);\n    font-size: 0.9rem;\n    text-decoration: none;\n    font-weight: 500;\n    transition: var(--transition);\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.back-link a:hover {\n    color: var(--brand-primary);\n}\n\n.error-banner {\n    background-color: #FEF2F2;\n    border: 1px solid #FECACA;\n    color: var(--error);\n    padding: 12px;\n    border-radius: var(--radius-input);\n    font-size: 0.9rem;\n    text-align: center;\n}\n\n.success-state {\n    text-align: center;\n    padding: 20px 0;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 16px;\n    animation: fadeIn 0.5s ease;\n}\n\n.success-icon {\n    width: 64px;\n    height: 64px;\n    background-color: #DCFCE7;\n    color: #16A34A;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 32px;\n    margin-bottom: 8px;\n}\n\n.success-text {\n    color: var(--text-muted);\n    font-size: 0.95rem;\n    line-height: 1.5;\n}\n\n@media (max-width: 480px) {\n    .forgot-page-wrapper {\n        padding: 0;\n        background-color: var(--bg-card);\n    }\n\n    .auth-card {\n        box-shadow: none;\n        height: 100vh;\n        justify-content: center;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
